export const environment = {
  production: false,
  api: {
    url: 'https://game.malariaspot.org/api',
    appId: 'ANJVot5ZKsD5iFFNo9RMgyL4sFHvdad75eaeI1Ai',
    jsKey: 'ezOpes6mHy9COnAk3nhiCjDS3YwX7LCsXf53qk2Q',
    clientKey: 'GtkgTw2qnSB0oWkyM5Zhc6ZXpo36Ko6sMwUkxwuF',
  },
};
